import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  addListingToFavoritesRequest: ['listingId'],
  addListingToFavoritesSuccess: ['data'],
  addListingToFavoritesFailure: ['error'],
  getFavoriteListingRequest: ['listingId'],
  getFavoriteListingSuccess: ['data'],
  getFavoriteListingFailure: ['error'],
  fetchFavoriteListingsRequest: ['options'],
  fetchFavoriteListingsSuccess: ['result'],
  fetchFavoriteListingsFailure: ['error'],
  removeListingFromFavoritesRequest: ['listingId'],
  removeListingFromFavoritesSuccess: ['data'],
  removeListingFromFavoritesFailure: ['error'],
  addLeadToFavoritesRequest: ['leadId'],
  addLeadToFavoritesSuccess: ['data'],
  addLeadToFavoritesFailure: ['error'],
  fetchFavoriteLeadsRequest: ['options'],
  fetchFavoriteLeadsSuccess: ['result'],
  fetchFavoriteLeadsFailure: ['error'],
  removeLeadFromFavoritesRequest: ['leadId'],
  removeLeadFromFavoritesSuccess: ['data'],
  removeLeadFromFavoritesFailure: ['error'],
  clearFavoritesStatus: null,
})

export const FavoritesTypes = Types
export const FavoritesActions = Creators

const INITIAL_STATE = {
  addingListingFavorite: false,
  listingAddedSuccess: null,
  addListingFavoriteError: null,
  checkingFavoriteListing: false,
  favoriteListing: null,
  getFavoriteListingError: null,
  gettingFavoriteListings: false,
  favoriteListingsSuccess: null,
  getFavoriteListingsError: null,
  removingListingFavorite: false,
  listingRemovedSuccess: null,
  removeListingFavoriteError: null,
  addingLeadFavorite: false,
  leadAddedSuccess: null,
  addLeadFavoriteError: null,
  gettingFavoriteLeads: false,
  favoriteLeadsSuccess: null,
  getFavoriteLeadsError: null,
  removingLeadFavorite: false,
  leadRemovedSuccess: null,
  removeLeadFavoriteError: null,
}

const addListingToFavoritesRequest = (state) => ({
  ...state,
  addingListingFavorite: true,
  listingAddedSuccess: null,
  addListingFavoriteError: null,
})

const addListingToFavoritesSuccess = (state, action) => ({
  ...state,
  addingListingFavorite: false,
  listingAddedSuccess: action.data,
  addListingFavoriteError: null,
})

const addListingToFavoritesFailure = (state, action) => ({
  ...state,
  addingListingFavorite: false,
  listingAddedSuccess: null,
  addListingFavoriteError: action.error,
})

const getFavoriteListingRequest = (state) => ({
  ...state,
  checkingFavoriteListing: true,
  favoriteListing: null,
  getFavoriteListingError: null,
})

const getFavoriteListingSuccess = (state, action) => ({
  ...state,
  checkingFavoriteListing: false,
  favoriteListing: action.data,
  getFavoriteListingError: null,
})

const getFavoriteListingFailure = (state, action) => ({
  ...state,
  checkingFavoriteListing: false,
  favoriteListing: null,
  getFavoriteListingError: action.error,
})

const fetchFavoriteListingsRequest = (state) => ({
  ...state,
  gettingFavoriteListings: true,
  getFavoriteListingsError: null,
})

const fetchFavoriteListingsSuccess = (state, action) => ({
  ...state,
  gettingFavoriteListings: false,
  favoriteListingsSuccess: action.result,
  getFavoriteListingsError: null,
})

const fetchFavoriteListingsFailure = (state, action) => ({
  ...state,
  gettingFavoriteListings: false,
  getFavoriteListingsError: action.error,
})

const removeListingFromFavoritesRequest = (state) => ({
  ...state,
  removingListingFavorite: true,
  listingRemovedSuccess: null,
  removeListingFavoriteError: null,
})

const removeListingFromFavoritesSuccess = (state, action) => ({
  ...state,
  removingListingFavorite: false,
  listingRemovedSuccess: action.data,
  removeListingFavoriteError: null,
})

const removeListingFromFavoritesFailure = (state, action) => ({
  ...state,
  removingListingFavorite: false,
  listingRemovedSuccess: null,
  removeListingFavoriteError: action.error,
})

const addLeadToFavoritesRequest = (state) => ({
  ...state,
  addingLeadFavorite: true,
  leadAddedSuccess: null,
  addLeadFavoriteError: null,
})

const addLeadToFavoritesSuccess = (state, action) => ({
  ...state,
  addingLeadFavorite: false,
  leadAddedSuccess: action.data,
  addLeadFavoriteError: null,
})

const addLeadToFavoritesFailure = (state, action) => ({
  ...state,
  addingLeadFavorite: false,
  leadAddedSuccess: null,
  addLeadFavoriteError: action.error,
})

const fetchFavoriteLeadsRequest = (state) => ({
  ...state,
  gettingFavoriteLeads: true,
  getFavoriteLeadsError: null,
})

const fetchFavoriteLeadsSuccess = (state, action) => ({
  ...state,
  gettingFavoriteLeads: false,
  favoriteLeadsSuccess: action.result,
  getFavoriteLeadsError: null,
})

const fetchFavoriteLeadsFailure = (state, action) => ({
  ...state,
  gettingFavoriteLeads: false,
  getFavoriteLeadsError: action.error,
})

const removeLeadFromFavoritesRequest = (state) => ({
  ...state,
  removingLeadFavorite: true,
  leadRemovedSuccess: null,
  removeLeadFavoriteError: null,
})

const removeLeadFromFavoritesSuccess = (state, action) => ({
  ...state,
  removingLeadFavorite: false,
  leadRemovedSuccess: action.data,
  removeLeadFavoriteError: null,
})

const removeLeadFromFavoritesFailure = (state, action) => ({
  ...state,
  removingLeadFavorite: false,
  leadRemovedSuccess: null,
  removeLeadFavoriteError: action.error,
})

const clearFavoritesStatus = (state) => ({
  ...state,
  addingListingFavorite: false,
  listingAddedSuccess: null,
  addListingFavoriteError: null,
  checkingFavoriteListing: false,
  favoriteListing: null,
  getFavoriteListingError: null,
  removingListingFavorite: false,
  listingRemovedSuccess: null,
  removeListingFavoriteError: null,
  addingLeadFavorite: false,
  leadAddedSuccess: null,
  addLeadFavoriteError: null,
  removingLeadFavorite: false,
  leadRemovedSuccess: null,
  removeLeadFavoriteError: null,
})

export default createReducer(INITIAL_STATE, {
  [Types.ADD_LISTING_TO_FAVORITES_REQUEST]: addListingToFavoritesRequest,
  [Types.ADD_LISTING_TO_FAVORITES_SUCCESS]: addListingToFavoritesSuccess,
  [Types.ADD_LISTING_TO_FAVORITES_FAILURE]: addListingToFavoritesFailure,
  [Types.GET_FAVORITE_LISTING_REQUEST]: getFavoriteListingRequest,
  [Types.GET_FAVORITE_LISTING_SUCCESS]: getFavoriteListingSuccess,
  [Types.GET_FAVORITE_LISTING_FAILURE]: getFavoriteListingFailure,
  [Types.FETCH_FAVORITE_LISTINGS_REQUEST]: fetchFavoriteListingsRequest,
  [Types.FETCH_FAVORITE_LISTINGS_SUCCESS]: fetchFavoriteListingsSuccess,
  [Types.FETCH_FAVORITE_LISTINGS_FAILURE]: fetchFavoriteListingsFailure,
  [Types.REMOVE_LISTING_FROM_FAVORITES_REQUEST]: removeListingFromFavoritesRequest,
  [Types.REMOVE_LISTING_FROM_FAVORITES_SUCCESS]: removeListingFromFavoritesSuccess,
  [Types.REMOVE_LISTING_FROM_FAVORITES_FAILURE]: removeListingFromFavoritesFailure,
  [Types.ADD_LEAD_TO_FAVORITES_REQUEST]: addLeadToFavoritesRequest,
  [Types.ADD_LEAD_TO_FAVORITES_SUCCESS]: addLeadToFavoritesSuccess,
  [Types.ADD_LEAD_TO_FAVORITES_FAILURE]: addLeadToFavoritesFailure,
  [Types.FETCH_FAVORITE_LEADS_REQUEST]: fetchFavoriteLeadsRequest,
  [Types.FETCH_FAVORITE_LEADS_SUCCESS]: fetchFavoriteLeadsSuccess,
  [Types.FETCH_FAVORITE_LEADS_FAILURE]: fetchFavoriteLeadsFailure,
  [Types.REMOVE_LEAD_FROM_FAVORITES_REQUEST]: removeLeadFromFavoritesRequest,
  [Types.REMOVE_LEAD_FROM_FAVORITES_SUCCESS]: removeLeadFromFavoritesSuccess,
  [Types.REMOVE_LEAD_FROM_FAVORITES_FAILURE]: removeLeadFromFavoritesFailure,
  [Types.CLEAR_FAVORITES_STATUS]: clearFavoritesStatus,
})